import React from 'react'

const Bolt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 18">
      <path fill="#B5D2E1" fillRule="evenodd" d="M.168 10.46l5.48-.695L2.12 17.45 11.17 6.619l-5.685.72L7.787.496z"/>
  </svg>
)

export default Bolt



// WEBPACK FOOTER //
// ./src/components/pages/ResetPassword/PasswordHints/bolt.js